function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.0594 3.23956L8.04594 0.035256C7.95673 -0.0123574 7.84981 -0.0116892 7.76126 0.0369267L1.91416 3.24123C1.81826 3.29386 1.75879 3.39443 1.75879 3.50386V7.6895C1.7623 11.1302 3.80082 14.243 6.95334 15.6214L7.76494 15.9751C7.84078 16.0082 7.92716 16.0083 8.00317 15.9754L8.91768 15.5805C12.1287 14.2319 14.2176 11.0891 14.218 7.60647V3.50386C14.218 3.39326 14.157 3.29152 14.0594 3.23956V3.23956ZM13.6192 7.60647C13.6186 10.849 11.6731 13.7748 8.68329 15.0297L8.68129 15.0307L7.88489 15.3745L7.19291 15.0726C4.25841 13.7895 2.36072 10.8923 2.35738 7.6895V3.68111L7.90711 0.63953L13.6192 3.68328V7.60647Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.69808 7.49533C5.59066 7.36953 5.40171 7.35466 5.27591 7.46208C5.15011 7.56934 5.13524 7.75846 5.24266 7.88409L6.82409 9.73601C6.92968 9.85964 7.11462 9.87651 7.24059 9.77393L10.9237 6.77745C11.052 6.6732 11.0714 6.48458 10.967 6.35628C10.8627 6.22814 10.6741 6.20859 10.5458 6.31301L7.08956 9.12472L5.69808 7.49533Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgShield = function SvgShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield.5b91a211.svg";
export { ForwardRef as ReactComponent };